import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CreateMoonsenseBundleRequest } from '@cash-web/shared-util-protos/squareup/cash/behavioraldatapoc/api/v1/service.pb'
import { CreateMoonsenseBundleResponse } from '@cash-web/shared-util-protos/squareup/cash/behavioraldatapoc/api/v1/service.pb'

export const createMoonsenseBundle = (request: CreateMoonsenseBundleRequest, options?: CashRequestOptions) =>
  post<CreateMoonsenseBundleRequest, CreateMoonsenseBundleResponse>('/2.0/cash/create-moonsense-bundle', request, {
    ...options,
    rejectOnError: true,
  })
